export const sizes = {
  sm: 'h-5 w-10',
  md: 'h-6 w-12',
};
